import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import axios from "axios";
import Header from '../Components/Header';
import { Link } from "react-router-dom";
import {
  FaArrowLeft,
  FaPlusCircle,
  FaMinusCircle,
  FaHistory,
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaCoins,
  FaWallet,
  FaInfoCircle,
  FaExchangeAlt
} from "react-icons/fa";

const Transactionhistory = () => {
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;

  let baseUrl;
  if (nodeMode === "development") {
    baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  const [user, setUser] = useState(null);
  const [cardData, setGame] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);

  // Pagination config
  const limit = 10; // set pagination limit to 10 for better UI scrollability
  const [pageNumber, setPageNumber] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const role = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`
    };
    try {
      const res = await axios.get(baseUrl + `me`, { headers });
      setUser(res.data);
      if (res.data && res.data._id) {
        Allgames(res.data._id, pageNumber);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.error("Error fetching user profile:", err);
      setLoading(false);
    }
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
  };

  const dateFormat = (e) => {
    if (!e) return "N/A";
    const date = new Date(e);
    return date.toLocaleString('default', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  };

  const Allgames = async (id, pageNum) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`
    };
    try {
      const res = await axios.get(baseUrl + `temp/deposite/${id}?page=${pageNum}&_limit=${limit}`, { headers });
      if (res.data) {
        setGame(res.data.ress || []);
        setTotalRecords(res.data.totalRecord || 0);
        setNumberOfPages(res.data.totalPages || 0);
      }
    } catch (err) {
      console.error("Error fetching transactions history:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    role();
    // eslint-disable-next-line
  }, [pageNumber]);

  return (
    <div style={{ backgroundColor: "#0b1426", minHeight: "100vh", color: "#fff" }}>
      {/* Embedded CSS for premium UI styling and transitions */}
      <style>{`
        .border-gradient {
          border: 2px solid transparent;
          border-image: linear-gradient(to right, #ff416c, #ff4b2b) 1;
        }
        .ref-card-bg {
          background: linear-gradient(135deg, rgba(20, 35, 60, 0.9) 0%, rgba(13, 23, 42, 0.95) 100%);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 16px;
          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        }
        .ref-card-bg:hover {
          transform: translateY(-4px);
          border-color: rgba(60, 214, 60, 0.4);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4);
        }
        .gradient-header {
          background: linear-gradient(135deg, #1e3c72 0%, #1a2a6c 50%, #240b36 100%);
          border-bottom: 2px solid rgba(255, 255, 255, 0.1);
        }
        .stat-card {
          background: rgba(255, 255, 255, 0.04);
          border: 1px solid rgba(255, 255, 255, 0.06);
          border-radius: 12px;
          padding: 12px 16px;
          flex: 1;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .animate-fade-in {
          animation: fadeIn 0.6s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        /* Custom status badges */
        .status-badge-success {
          background: rgba(60, 214, 60, 0.15);
          color: #3cd63c;
          font-size: 0.72rem;
          padding: 4px 10px;
          border-radius: 20px;
          border: 1px solid rgba(60, 214, 60, 0.3);
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        .status-badge-pending {
          background: rgba(255, 193, 7, 0.15);
          color: #ffc107;
          font-size: 0.72rem;
          padding: 4px 10px;
          border-radius: 20px;
          border: 1px solid rgba(255, 193, 7, 0.3);
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        .status-badge-failed {
          background: rgba(220, 53, 69, 0.15);
          color: #dc3545;
          font-size: 0.72rem;
          padding: 4px 10px;
          border-radius: 20px;
          border: 1px solid rgba(220, 53, 69, 0.3);
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        /* Premium custom style for ReactPaginate */
        .pagination {
          display: flex;
          padding-left: 0;
          list-style: none;
          border-radius: 0.25rem;
          justify-content: center;
          align-items: center;
          gap: 6px;
        }
        .page-item .page-link {
          background: rgba(255, 255, 255, 0.05) !important;
          border: 1px solid rgba(255, 255, 255, 0.1) !important;
          color: #fff !important;
          padding: 8px 16px;
          border-radius: 8px !important;
          transition: all 0.2s;
        }
        .page-item:hover .page-link {
          background: rgba(60, 214, 60, 0.2) !important;
          border-color: rgba(60, 214, 60, 0.4) !important;
          color: #3cd63c !important;
        }
        .page-item.active .page-link {
          background: #3cd63c !important;
          border-color: #3cd63c !important;
          color: #0b1426 !important;
          font-weight: bold;
        }
        .page-item.disabled .page-link {
          opacity: 0.4;
          cursor: not-allowed;
          background: rgba(255, 255, 255, 0.02) !important;
        }
      `}</style>

      <Header user={user} />

      <div className="leftContainer animate-fade-in" style={{ minHeight: '100vh', height: '100%', paddingBottom: "100px" }}>

        {/* Dynamic Gradient Header Panel */}
        <div className="gradient-header p-4 text-white">
          <div className="d-flex align-items-center mb-3">
            <Link to="/wallet" className="text-white mr-3">
              <FaArrowLeft size={18} />
            </Link>
            <h4 className="m-0 font-weight-bold" style={{ letterSpacing: "0.5px" }}>Transaction History</h4>
          </div>

          <p className="text-white-50 small mb-4">
            Verify deposit orders, prize earnings, withdrawal requests, and balance adjustments instantly.
          </p>

          <div className="d-flex flex-wrap gap-3" style={{ gap: "12px" }}>
            <div className="stat-card">
              <div style={{ background: "rgba(255, 193, 7, 0.15)", borderRadius: "10px", padding: "10px", color: "#ffc107" }}>
                <FaWallet size={20} />
              </div>
              <div>
                <div className="text-white-50" style={{ fontSize: "0.75rem" }}>Wallet Balance</div>
                <h5 className="m-0 font-weight-bold">₹{(user?.Wallet_balance || 0).toFixed(2)}</h5>
              </div>
            </div>

            <div className="stat-card">
              <div style={{ background: "rgba(60, 214, 60, 0.15)", borderRadius: "10px", padding: "10px", color: "#3cd63c" }}>
                <FaExchangeAlt size={20} />
              </div>
              <div>
                <div className="text-white-50" style={{ fontSize: "0.75rem" }}>Total Records</div>
                <h5 className="m-0 font-weight-bold">{totalRecords}</h5>
              </div>
            </div>
          </div>
        </div>

        {/* Loading State */}
        {loading ? (
          <div className="d-flex flex-column align-items-center justify-content-center pt-5" style={{ minHeight: "35vh" }}>
            <div className="spinner-border text-success" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="mt-3 text-white-50 small">Loading transactions...</div>
          </div>
        ) : (
          <div className="mt-4 px-3">
            {/* List items */}
            {Array.isArray(cardData) && cardData.length > 0 ? (
              <div>
                {cardData.map((card, index) => {
                  const idStr = card._id ? card._id.toString() : "";
                  const timestampStr = idStr.slice(0, 8);
                  const counterid = parseInt(timestampStr, 16) || Math.floor(Math.random() * 1000000);

                  let titleMsg = "Transaction";
                  let signIcon = <FaClock className="text-warning" size={14} />;
                  let amountColor = "#fff";
                  let signStr = "";
                  let badge = (
                    <span className="status-badge-pending">
                      <FaClock size={10} /> Pending
                    </span>
                  );

                  const reqType = (card.Req_type || "").toLowerCase();
                  const isFailed = card.status === "FAILED";
                  const isPending = card.status === "Pending" || card.status === "none";
                  const isSuccess = card.status === "SUCCESS" || card.status === "Success" || card.status === "Successfull";

                  if ((reqType === "deposit" || reqType === "bonus") && !isFailed) {
                    titleMsg = reqType === "bonus" ? "Bonus Added" : "Cash Added";
                    amountColor = "#3cd63c";
                    signStr = "+";
                    signIcon = <FaPlusCircle className="text-success" size={16} />;

                    if (reqType === "bonus") {
                      badge = (
                        <span className="status-badge-success">
                          <FaCheckCircle size={10} /> Success
                        </span>
                      );
                    } else if (isPending && reqType === "deposit") {
                      badge = (
                        <span className="status-badge-pending">
                          <FaClock size={10} /> Cancelled
                        </span>
                      );
                    } else if (isSuccess) {
                      badge = (
                        <span className="status-badge-success">
                          <FaCheckCircle size={10} /> Success
                        </span>
                      );
                    }
                  } else if (reqType === "withdraw" && !isFailed) {
                    titleMsg = `Withdraw (${card.Withdraw_type || 'UPI'})`;
                    amountColor = "#dc3545";
                    signStr = "-";
                    signIcon = <FaMinusCircle className="text-danger" size={16} />;

                    if (isPending) {
                      badge = (
                        <span className="status-badge-pending">
                          <FaClock size={10} /> Processing
                        </span>
                      );
                    } else if (isSuccess) {
                      badge = (
                        <span className="status-badge-success">
                          <FaCheckCircle size={10} /> Success
                        </span>
                      );
                    }
                  } else if (reqType === "penalty" && !isFailed) {
                    titleMsg = "Penalty Deducted";
                    amountColor = "#dc3545";
                    signStr = "-";
                    signIcon = <FaMinusCircle className="text-danger" size={16} />;
                    badge = (
                      <span className="status-badge-failed">
                        <FaTimesCircle size={10} /> Deducted
                      </span>
                    );
                  } else if (reqType === "i win") {
                    titleMsg = "Battle Won";
                    amountColor = "#3cd63c";
                    signStr = "+";
                    signIcon = <FaPlusCircle className="text-success" size={16} />;
                    badge = (
                      <span className="status-badge-success">
                        <FaCheckCircle size={10} /> Victory
                      </span>
                    );
                  } else if (reqType === "i lose") {
                    titleMsg = "Battle Lost";
                    amountColor = "#dc3545";
                    signStr = "-";
                    signIcon = <FaMinusCircle className="text-danger" size={16} />;
                    badge = (
                      <span className="status-badge-failed">
                        <FaTimesCircle size={10} /> Defeat
                      </span>
                    );
                  } else {
                    titleMsg = isFailed ? "Order Failed" : card.Req_type || "Transaction";
                    badge = (
                      <span className="status-badge-failed">
                        <FaTimesCircle size={10} /> Failed
                      </span>
                    );
                    signIcon = <FaTimesCircle className="text-danger" size={16} />;
                  }

                  const rawDateStr = card.created_at || card.createdAt || "";
                  const formattedDate = dateFormat(rawDateStr);
                  const displayDate = formattedDate.split(',')[0] || "N/A";
                  const displayTime = formattedDate.split(',')[1] || "";

                  let txnMsgToShow = card.txn_msg || card.txnMsg;
                  if ((reqType === "penalty" || reqType === "bonus") && !txnMsgToShow) {
                    txnMsgToShow = card.status;
                  }

                  return (
                    <div className="ref-card-bg p-3 mb-3 d-flex align-items-center justify-content-between" key={card._id || index}>
                      <div className="d-flex align-items-center gap-3" style={{ gap: "14px" }}>
                        <div style={{
                          width: "45px",
                          height: "45px",
                          borderRadius: "12px",
                          background: "rgba(255,255,255,0.05)",
                          border: "1px solid rgba(255,255,255,0.08)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}>
                          {signIcon}
                        </div>
                        <div>
                          <div className="font-weight-bold text-white mb-1" style={{ fontSize: "0.95rem" }}>
                            {titleMsg}
                          </div>
                          <div className="text-white-50 small d-flex flex-wrap align-items-center gap-2" style={{ gap: "8px", fontSize: "0.72rem" }}>
                            <span>OrderID: <strong className="text-white">{counterid}</strong></span>
                            <span className="text-secondary">•</span>
                            <span>{displayDate} {displayTime}</span>
                          </div>
                          {txnMsgToShow && (
                            <div className="mt-2 text-warning small d-flex align-items-center gap-1" style={{ fontSize: "0.72rem", opacity: 0.9 }}>
                              <FaInfoCircle size={10} style={{ flexShrink: 0 }} />
                              <span>{txnMsgToShow}</span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="text-right">
                        <div className="d-flex align-items-center justify-content-end gap-1 mb-1" style={{ gap: "4px" }}>
                          <picture>
                            <img
                              alt="coins"
                              height="16px"
                              width="16px"
                              src={process.env.PUBLIC_URL + '/Images/kd_ludo/coin_icon.gif'}
                              style={{ display: "inline-block", verticalAlign: "middle" }}
                            />
                          </picture>
                          <span style={{ fontSize: "1.1rem", fontWeight: "bold", color: amountColor }}>
                            {signStr}₹{card.amount}
                          </span>
                        </div>

                        <div className="d-flex align-items-center justify-content-end gap-2" style={{ gap: "8px" }}>
                          {badge}
                          {card.closing_balance !== undefined && (
                            <span className="text-white-50" style={{ fontSize: "0.68rem" }}>
                              Closing: ₹{card.closing_balance}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* Paginate wrapper */}
                {numberOfPages > 1 && (
                  <div className="py-4">
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={numberOfPages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                      forcePage={pageNumber - 1}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="text-center px-4 py-5 animate-fade-in" style={{ marginTop: "15%" }}>
                <img
                  src={process.env.PUBLIC_URL + '/Images/notransactionhistory.png'}
                  alt="no transactions"
                  width={220}
                  height={220}
                  className="img-fluid mb-4 animate__animated animate__fadeIn"
                  style={{ opacity: 0.8 }}
                />
                <h4 className="font-weight-bold">No Transactions Found</h4>
                <p className="text-white-50 mx-auto small" style={{ maxWidth: "300px" }}>
                  Your deposit deposits, withdrawals, and platform play histories will register here once initiated.
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Transactionhistory;
